<div class="app-page">
  <div class="app-page-header">
    <div class="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
      <div>
        <h1 class="section-title">{{ isEditMode() ? 'Editar Orden' : 'Nueva Orden' }}</h1>
        <p class="section-subtitle">
          {{ isEditMode() ? 'Actualizá la orden de publicidad' : 'Creá una nueva orden de publicidad' }}
        </p>
      </div>
      <div class="flex flex-wrap gap-2">
        @if (isEditMode()) {
          <button
            pButton
            type="button"
            label="Exportar JSON"
            icon="pi pi-download"
            class="p-button-outlined"
            (click)="exportarOrden()"
            [disabled]="loading()">
          </button>
        }
        @if (ordenForm.invalid) {
          <button
            pButton
            type="button"
            label="Ver Errores"
            icon="pi pi-exclamation-circle"
            class="p-button-outlined p-button-warning"
            (click)="mostrarErrores()"
            [disabled]="loading()">
          </button>
        }
        <button
          pButton
          type="button"
          label="Cancelar"
          icon="pi pi-times"
          class="p-button-outlined"
          (click)="onCancel()"
          [disabled]="loading()">
        </button>
        <button
          pButton
          type="button"
          label="Guardar"
          icon="pi pi-check"
          class="p-button"
          (click)="onSubmit()"
          [disabled]="loading() || ordenForm.invalid"
          [loading]="loading()">
        </button>
      </div>
    </div>
  </div>

  <div class="app-page-content edit-layout">
    @if (isEditMode()) {
      <div class="app-card quick-summary">
        <div class="grid grid-cols-1 gap-3 md:grid-cols-4">
          <div>
            <p class="text-xs uppercase text-muted">Neto preview</p>
            <p class="text-lg font-semibold">{{ totals().neto | currencyFormat:'$' }}</p>
            @if (confirmedTotals()) {
              <p class="text-xs text-muted">Confirmado: {{ (confirmedTotals()?.total ?? 0) | currencyFormat:'$' }}</p>
            }
          </div>
          <div>
            <p class="text-xs uppercase text-muted">Descuento</p>
            <p class="text-lg font-semibold">{{ totals().descuento | number:'1.0-2' }}%</p>
            <p class="text-xs text-muted">{{ totals().descuentoMonto | currencyFormat:'$' }}</p>
          </div>
          <div>
            <p class="text-xs uppercase text-muted">Bruto preview</p>
            <p class="text-lg font-semibold">{{ totals().bruto | currencyFormat:'$' }}</p>
          </div>
          <div>
            <p class="text-xs uppercase text-muted">Comisión</p>
            <p class="text-lg font-semibold">{{ totals().comision | currencyFormat:'$' }}</p>
          </div>
        </div>
      </div>
    }
    <form [formGroup]="ordenForm" (ngSubmit)="onSubmit()" class="edit-form" #formContainer>
      <div class="grid grid-cols-1 gap-6 2xl:grid-cols-2">
        <div class="app-card border border-black/5 dark:border-white/10 rounded-2xl p-4 sm:p-5">
          <div class="flex items-center justify-between">
            <div>
              <p class="text-xs uppercase tracking-wide text-muted">Datos de la orden</p>
              <h2 class="text-lg font-semibold" style="color: hsl(var(--text));">Datos de la Orden</h2>
            </div>
          </div>

          <div class="grid grid-cols-1 gap-4 mt-4 md:[grid-template-columns:repeat(auto-fit,minmax(240px,1fr))]">
            <div class="space-y-2">
              <label for="numero" class="text-sm font-medium" style="color: hsl(var(--text));">
                Número de Orden *
              </label>
              <input
                pInputText
                id="numero"
                formControlName="numero"
                type="text"
                placeholder="OP-0001"
                class="w-full"
                [class.border-red-500]="ordenForm.get('numero')?.invalid && ordenForm.get('numero')?.touched"
              />
              @if (ordenForm.get('numero')?.invalid && ordenForm.get('numero')?.touched) {
                <small class="text-sm block" style="color: hsl(var(--danger));">
                  Número es requerido
                </small>
              }
            </div>

            <div class="space-y-2">
              <label for="fechaIngreso" class="text-sm font-medium" style="color: hsl(var(--text));">
                Fecha de Ingreso *
              </label>
              <p-datepicker
                id="fechaIngreso"
                formControlName="fechaIngreso"
                dateFormat="dd/mm/yy"
                [appendTo]="'body'"
                class="w-full">
              </p-datepicker>
            </div>

            <div class="space-y-2">
              <label for="tipoOrden" class="text-sm font-medium" style="color: hsl(var(--text));">
                Tipo de Orden *
              </label>
              <p-select
                id="tipoOrden"
                formControlName="tipoOrden"
                [options]="tipoOrdenOptions"
                optionLabel="label"
                optionValue="value"
                placeholder="Seleccionar..."
                [appendTo]="'body'"
                class="w-full">
              </p-select>
            </div>

            <div class="space-y-2">
              <label for="estado" class="text-sm font-medium" style="color: hsl(var(--text));">
                Estado *
              </label>
              <p-select
                id="estado"
                formControlName="estado"
                [options]="estadoOptions"
                optionLabel="label"
                optionValue="value"
                placeholder="Seleccionar..."
                [appendTo]="'body'"
                class="w-full">
              </p-select>
            </div>

            <div class="space-y-2">
              <label for="vigenciaDesde" class="text-sm font-medium" style="color: hsl(var(--text));">
                Vigencia desde
              </label>
              <p-datepicker
                id="vigenciaDesde"
                formControlName="vigenciaDesde"
                dateFormat="dd/mm/yy"
                [appendTo]="'body'"
                class="w-full">
              </p-datepicker>
            </div>

            <div class="space-y-2">
              <label for="vigenciaHasta" class="text-sm font-medium" style="color: hsl(var(--text));">
                Vigencia hasta
              </label>
              <p-datepicker
                id="vigenciaHasta"
                formControlName="vigenciaHasta"
                dateFormat="dd/mm/yy"
                [appendTo]="'body'"
                class="w-full">
              </p-datepicker>
            </div>

            <div class="space-y-2 md:col-span-2">
              <label for="tarifa" class="text-sm font-medium" style="color: hsl(var(--text));">
                Tarifario *
              </label>
              <p-select
                id="tarifa"
                formControlName="tarifa"
                [options]="tarifaOptions()"
                optionLabel="nombre"
                optionValue="id"
                placeholder="Seleccionar tarifario..."
                [appendTo]="'body'"
                class="w-full">
                <ng-template let-option pTemplate="item">
                  <div class="flex flex-col">
                    <span class="font-medium">{{ option?.codigo }}</span>
                    <span class="text-xs text-muted">{{ option?.nombre }}</span>
                  </div>
                </ng-template>
                <ng-template let-option pTemplate="selectedItem">
                  <span>{{ option?.codigo }} - {{ option?.nombre }}</span>
                </ng-template>
              </p-select>
              @if (!ordenForm.get('tarifa')?.value && itemsFormArray.length > 0) {
                <small class="text-sm block" style="color: hsl(var(--danger));">
                  Seleccioná un tarifario para calcular los ítems.
                </small>
              }
            </div>

            <div class="space-y-2">
              <label for="moneda" class="text-sm font-medium" style="color: hsl(var(--text));">
                Moneda
              </label>
              <p-select
                id="moneda"
                formControlName="moneda"
                [options]="monedaOptions"
                optionLabel="label"
                optionValue="value"
                [appendTo]="'body'"
                class="w-full">
              </p-select>
            </div>

            <div class="space-y-2">
              <label for="porcentajeComision" class="text-sm font-medium" style="color: hsl(var(--text));">
                Porcentaje Comisión *
              </label>
              <p-inputNumber
                id="porcentajeComision"
                formControlName="porcentajeComision"
                [min]="0"
                [max]="100"
                [maxFractionDigits]="2"
                class="w-full">
              </p-inputNumber>
            </div>

            <div class="space-y-2">
              <label for="descuento" class="text-sm font-medium" style="color: hsl(var(--text));">
                Descuento (%)
              </label>
              <p-inputNumber
                id="descuento"
                formControlName="descuento"
                [min]="0"
                [max]="100"
                [maxFractionDigits]="2"
                mode="decimal"
                class="w-full">
              </p-inputNumber>
            </div>

            <div class="space-y-2">
              <label for="esqueletoNombre" class="text-sm font-medium" style="color: hsl(var(--text));">
                Esqueleto (opcional)
              </label>
              <input
                pInputText
                id="esqueletoNombre"
                formControlName="esqueletoNombre"
                type="text"
                placeholder="Referencia de esqueleto"
                class="w-full"
              />
            </div>

            <div class="space-y-2 md:col-span-2">
              <label for="observaciones" class="text-sm font-medium" style="color: hsl(var(--text));">
                Observaciones
              </label>
              <textarea
                pTextarea
                id="observaciones"
                formControlName="observaciones"
                placeholder="Observaciones adicionales"
                class="w-full"
                rows="3">
              </textarea>
            </div>
          </div>
        </div>

        <div class="app-card border border-black/5 dark:border-white/10 rounded-2xl p-4 sm:p-5">
          <div class="flex items-center justify-between">
            <div>
              <p class="text-xs uppercase tracking-wide text-muted">Clientes y facturación</p>
              <h2 class="text-lg font-semibold" style="color: hsl(var(--text));">Clientes y Facturación</h2>
              <p class="text-xs text-muted mt-1">Asigná los roles de la orden y definí a quién se factura.</p>
            </div>
          </div>

          <div class="grid grid-cols-1 gap-4 mt-4 md:[grid-template-columns:repeat(auto-fit,minmax(240px,1fr))]">
            <div class="space-y-2">
              <label for="clientePrincipal" class="text-sm font-medium" style="color: hsl(var(--text));">
                Cliente Principal *
              </label>
              <div class="relative">
                <p-autoComplete
                  id="clientePrincipal"
                  formControlName="clientePrincipal"
                  [suggestions]="clientePrincipalSuggestions"
                  (completeMethod)="searchClientes($event, 'principal')"
                  optionLabel="razonSocial"
                  placeholder="Buscar cliente..."
                  [dropdown]="true"
                  [forceSelection]="true"
                  [appendTo]="'body'"
                  class="w-full">
                  <ng-template let-option pTemplate="item">
                    <div class="flex flex-col">
                      <span class="font-medium">{{ option.razonSocial }}</span>
                      <span class="text-xs text-muted">{{ option.cuit }}</span>
                    </div>
                  </ng-template>
                </p-autoComplete>
                @if (loadingClientes.clientePrincipal) {
                  <i class="pi pi-spin pi-spinner absolute right-3 top-1/2 -translate-y-1/2 text-muted"></i>
                }
              </div>
            </div>

            <div class="space-y-2">
              <label for="anunciante" class="text-sm font-medium" style="color: hsl(var(--text));">
                Anunciante
              </label>
              <div class="relative">
                <p-autoComplete
                  id="anunciante"
                  formControlName="anunciante"
                  [suggestions]="anuncianteSuggestions"
                  (completeMethod)="searchAnunciantes($event)"
                  (onDropdownClick)="searchAnunciantes({ query: '' })"
                  [minLength]="0"
                  [completeOnFocus]="true"
                  optionLabel="razonSocial"
                  placeholder="Buscar anunciante..."
                  [dropdown]="true"
                  [forceSelection]="true"
                  [appendTo]="'body'"
                  class="w-full">
                  <ng-template let-option pTemplate="item">
                    <div class="flex flex-col">
                      <span class="font-medium">{{ option.razonSocial }}</span>
                      <span class="text-xs text-muted">{{ option.cuit }}</span>
                    </div>
                  </ng-template>
                </p-autoComplete>
                @if (loadingClientes.anunciante) {
                  <i class="pi pi-spin pi-spinner absolute right-3 top-1/2 -translate-y-1/2 text-muted"></i>
                }
              </div>
            </div>

            <div class="space-y-2">
              <label for="productor" class="text-sm font-medium" style="color: hsl(var(--text));">
                Productor
              </label>
              <div class="relative">
                <p-autoComplete
                  id="productor"
                  formControlName="productor"
                  [suggestions]="productorSuggestions"
                  (completeMethod)="searchClientes($event, 'productor')"
                  optionLabel="razonSocial"
                  placeholder="Buscar productor..."
                  [dropdown]="true"
                  [forceSelection]="true"
                  [appendTo]="'body'"
                  class="w-full">
                  <ng-template let-option pTemplate="item">
                    <div class="flex flex-col">
                      <span class="font-medium">{{ option.razonSocial }}</span>
                      <span class="text-xs text-muted">{{ option.cuit }}</span>
                    </div>
                  </ng-template>
                </p-autoComplete>
                @if (loadingClientes.productor) {
                  <i class="pi pi-spin pi-spinner absolute right-3 top-1/2 -translate-y-1/2 text-muted"></i>
                }
              </div>
            </div>

            <div class="space-y-2 md:col-span-2">
              <label for="facturacionRol" class="text-sm font-medium" style="color: hsl(var(--text));">
                Facturar a *
              </label>
              <p-select
                id="facturacionRol"
                formControlName="facturacionRol"
                [options]="facturacionOptions()"
                optionLabel="label"
                optionValue="value"
                [optionDisabled]="'disabled'"
                placeholder="Seleccionar..."
                [appendTo]="'body'"
                class="w-full">
              </p-select>
              @if (facturacionResumen().ok) {
                <div class="flex items-center gap-2 text-xs text-muted">
                  <span class="inline-flex h-1.5 w-1.5 rounded-full bg-emerald-400"></span>
                  <span>{{ facturacionResumen().text }}</span>
                </div>
              } @else {
                <div class="flex items-center gap-2 text-xs text-muted">
                  <span class="inline-flex items-center gap-1 rounded-full border border-amber-400/40 bg-amber-400/10 px-2 py-0.5 text-amber-200">
                    Definir facturación
                  </span>
                  <span>Seleccioná un rol para facturar.</span>
                </div>
              }
            </div>
          </div>
        </div>
      </div>

      <div class="app-card mt-6">
        <div class="flex items-center justify-between mb-4">
          <div>
            <h2 class="text-xl font-semibold" style="color: hsl(var(--text));">Ítems de Emisión</h2>
            <p class="text-sm text-muted">Detalle de emisiones por programa y material</p>
          </div>
        </div>

        @if (validationSummary().length > 0) {
          <div class="validation-summary">
            <div class="validation-summary__title">Faltan campos para guardar:</div>
            <ul>
              @for (item of validationSummary(); track $index) {
                <li>{{ item }}</li>
              }
            </ul>
          </div>
        }

        <app-items-emision-section
          [itemsFormArray]="itemsFormArray"
          [readOnly]="loading()"
          [itemsLoading]="itemsLoading()"
          [vigenciaDesde]="ordenForm.get('vigenciaDesde')?.value"
          [vigenciaHasta]="ordenForm.get('vigenciaHasta')?.value">
        </app-items-emision-section>
      </div>

      <div class="app-card mt-6">
        <div class="grid grid-cols-1 gap-4 md:grid-cols-5">
          <div>
            <p class="text-xs uppercase text-muted">Duración total (seg)</p>
            <p class="text-lg font-semibold">{{ totals().duracionTotal }}</p>
            @if (confirmedTotals()) {
              <p class="text-xs text-muted">Confirmado: {{ confirmedTotals()?.duracionTotal ?? 0 }}</p>
            }
          </div>
          <div>
            <p class="text-xs uppercase text-muted">Bruto</p>
            <p class="text-lg font-semibold">{{ totals().bruto | currencyFormat }}</p>
          </div>
          <div>
            <p class="text-xs uppercase text-muted">Descuento</p>
            <p class="text-lg font-semibold">{{ totals().descuento | number:'1.0-2' }}%</p>
            <p class="text-xs text-muted">{{ totals().descuentoMonto | currencyFormat }}</p>
          </div>
          <div>
            <p class="text-xs uppercase text-muted">Neto</p>
            <p class="text-lg font-semibold">{{ totals().neto | currencyFormat }}</p>
            @if (confirmedTotals()) {
              <p class="text-xs text-muted">Confirmado: {{ (confirmedTotals()?.total ?? 0) | currencyFormat }}</p>
            }
          </div>
          <div>
            <p class="text-xs uppercase text-muted">Comisión</p>
            <p class="text-lg font-semibold">{{ totals().comision | currencyFormat }}</p>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
